import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, Dependencies } from '../types';
import { SubSchedule } from '../../webAccessControlSchedulerApp/types';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { translateFn } from '../../../utils/translator.helper';

export class WebAccessControlSchedulerFormGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys>  {
  private allData: Array<SubSchedule> = [];

  constructor(public dependencies: Dependencies) {
    super();
    this.allData = this.dependencies.schedule?.subschedules as unknown as Array<SubSchedule>;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    const summary = this.allData.length;

    return {
      summary: translateFn('{noOfItems} items', { noOfItems: summary }),
      numItems: summary,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<SubSchedule> }> {
    const data: Array<SubSchedule> = this.allData;
    return {rawEvents: data};
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }
}
